import { Navigate, Route, Routes, Link } from "react-router-dom";
import { useAuth } from "./auth";
import { LoginPage } from "./pages/LoginPage";
import { ListPage } from "./pages/ListPage";
import { EditPage } from "./pages/EditPage";

function Header() {
  const { user, signOut } = useAuth();
  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
        <Link to="/" className="text-sm font-bold text-brand-dark">
          Painel · Farmácias
        </Link>
        {user && (
          <div className="flex items-center gap-3 text-sm text-slate-600">
            <span className="hidden sm:inline">{user.email}</span>
            <button className="btn-ghost !px-3 !py-1" onClick={() => void signOut()}>
              Sair
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export function App() {
  const { user, allowed, loading } = useAuth();

  if (loading) {
    return <div className="p-10 text-center text-slate-500">Carregando…</div>;
  }

  if (!user || !allowed) {
    return <LoginPage />;
  }

  return (
    <div className="min-h-screen">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-6">
        <Routes>
          <Route path="/" element={<ListPage />} />
          <Route path="/nova" element={<EditPage mode="create" />} />
          <Route path="/f/:slug" element={<EditPage mode="edit" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
